import { Spinner } from '@increasecard/typed-components';

export default function LoadingIndicator({ size = 64 }: { size?: number }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        height: '100%',
        width: '100%',
      }}
    >
      <Spinner size={size} />
    </div>
  );
}
